export default class Clock
{
  now: number;
  then: number;
  timeModifier: number;

  constructor()
  {
    this.now = Date.now();
    this.then = Date.now();
    this.timeModifier = 1;
  }

  getMillisecondsSinceLastTick(): number
  {
    this.now = Date.now();
    const timeElapsed = (this.now - this.then); // unit: ms
    this.then = this.now;
    return timeElapsed * this.timeModifier;
  }

  getSecondsSinceLastTick(): number
  {
    return this.getMillisecondsSinceLastTick() / 1000;
  }
}